import type { Uuid } from '@common/types';

import type { TabsState } from './tabs.reducer';
import type { PageStructureState } from '../page-structure-feature.reducer';

import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';

import { selectWidgetsEntities } from '@web/store/page-structure/widgets/widgets.selectors';
import { selectGridsEntities } from '@web/store/page-structure/grids/grids.selectors';
import { tabSchema } from '@web/store/page-structure/page-structure/mockStructureData';

import { TAB_FEATURE_KEY, tabsAdapter } from './tabs.reducer';
import { pageStructureState } from '../page-structure-state.selectors';

const { selectAll, selectEntities, selectIds } = tabsAdapter.getSelectors();

// Lookup the 'Tabs' feature state managed by NgRx
export const selectTabsState = createSelector(
    pageStructureState,
    (state: PageStructureState): TabsState => state[TAB_FEATURE_KEY]
);

export const selectAllTabs = createSelector(selectTabsState, (state: TabsState) => selectAll(state));

export const selectTabsEntities = createSelector(selectTabsState, (state: TabsState) => selectEntities(state));

export const selectTabsIds = createSelector(selectTabsState, (state: TabsState) => selectIds(state));

export const selectTabById = (id: Uuid) => createSelector(selectTabsEntities, (entities) => entities[id]);

export const selectTabEntityById = (id: Uuid) =>
    createSelector(selectTabsEntities, selectGridsEntities, selectWidgetsEntities, (tabs, grids, widgets) => {
        const normalizedTab = {
            widgets: {
                ...widgets,
                ...grids,
                ...tabs,
            },
        };

        return denormalize(id, tabSchema, normalizedTab);
    });
